<template>
  <div class="rentpress-shortcode-single-floorplan-page-wrapper">
    <single-floorplan-information
      ref="floorplanInformation"
      :floorplan="floorplan"
      :options="options"
      :formatter="formatter"
      :shortcode="shortcode"
      @selected-unit="setSelectedUnit"
    />
    <v-card
      class="rentpress-single-floorplan-page-info-row"
      color="#F9F9F9"
      outlined
      v-if="
        floorplan.floorplan_description ||
          floorplan.property_description ||
          community_amenities.length > 0 ||
          floorplanFeaturesExcludingUnitsButInAllUnits.length > 0 ||
          floorplan.property_pet_policy ||
          hasOfficeHours
      "
    >
      <v-container fluid>
        <v-row
          class="text-left rentpress-shortcode-single-floorplan-page-row"
          justify="center"
        >
          <v-col
            v-if="floorplan.floorplan_description"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="auto"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="
                    rentpress-inherited-font-family
                    text-h5
                    secondary--text
                    rentpress-single-floorplan-about-title
                  "
                >
                  About This Apartment
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <p
                  class="rentpress-inherited-font-family text-wrap text-body-1 rentpress-floorplan-about-section"
                >
                  {{ floorplan.floorplan_description }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            v-else-if="floorplan.property_description"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="auto"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="
                    rentpress-inherited-font-family
                    text-h5
                    secondary--text
                  "
                  v-html="'About Our Community - ' + floorplan.property_name"
                ></h3>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <p
                  class="
                    rentpress-floorplan-about-section
                    rentpress-inherited-font-family
                    text-body-1
                  "
                  v-html="floorplan.property_description"
                ></p>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            id="rentpress-amenities"
            v-if="community_amenities.length > 0"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="auto"
            class="rentpress-single-floorplan-amenities-wrapper"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="
                    rentpress-inherited-font-family
                    text-h5
                    secondary--text
                    rentpress-single-floorplan-amenities-title
                  "
                >
                  Community Amenities
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-row no-gutters justify="space-between">
              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                cols="auto"
                id="community_amenities"
              >
                <div
                  v-for="(amenity, index) in community_amenities"
                  :key="index"
                  class="rentpress-inherited-font-family text-body-2 pb-2"
                >
                  <v-icon class="primary--text">{{
                    $vuetify.icons.values.next
                  }}</v-icon>
                  {{ amenity }}
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="floorplanFeaturesExcludingUnitsButInAllUnits.length > 0"
            id="floorplan-features"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="12"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="
                    rentpress-inherited-font-family
                    text-h5
                    secondary--text
                  "
                >
                  Floor Plan Features
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-row no-gutters justify="space-between">
              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                cols="auto"
                id="floorplan_features"
              >
                <div
                  v-for="(amenity,
                  index) in floorplanFeaturesExcludingUnitsButInAllUnits"
                  :key="index"
                  class="rentpress-inherited-font-family text-body-2 pb-2"
                >
                  <v-icon class="primary--text">{{
                    $vuetify.icons.values.next
                  }}</v-icon>
                  {{ amenity }}
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="text-left rentpress-pet-policy-container"
            v-if="floorplan.property_pet_policy"
            xl="8"
            lg="8"
            md="12"
            sm="12"
            cols="auto"
            id="property-pet-policy"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="
                    rentpress-inherited-font-family
                    text-h5
                    secondary--text
                  "
                  v-html="floorplan.property_name + ' Pet Policy'"
                ></h3>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  class="
                    rentpress-inherited-font-family
                    text-wrap text-body-1
                    pre-formatted
                  "
                  v-html="floorplan.property_pet_policy"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            v-if="hasOfficeHours"
            class="rentpress-office-hours-container"
            xl="4"
            lg="4"
            md="12"
            sm="12"
            cols="12"
            id="property-office-hours"
          >
            <v-list-item class="rentpress-office-hours-title">
              <v-list-item-content>
                <h3
                  class="
                    rentpress-inherited-font-family
                    text-h5
                    secondary--text
                    rentpress-single-floorplan-hours-title
                  "
                >
                  Office Hours
                </h3>
              </v-list-item-content>
            </v-list-item>
            <ul class="rentpress-office-hours-list">
              <li v-for="(officeHour, day) in officeHours" :key="day">
                <span
                  v-if="officeHour"
                  class="rentpress-inherited-font-family text-body-2"
                  :class="today == day ? 'font-weight-black' : ''"
                >
                  <v-icon class="primary--text">{{
                    $vuetify.icons.values.next
                  }}</v-icon>
                  {{ day }}: <span v-html="officeHour"></span>
                </span>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div v-if="floorplan.floorplan_matterport_url" id="rentpress-virtual-tour">
      <v-row justify="center">
        <v-col cols="auto">
          <h3 class="rentpress-inherited-font-family text-h4 secondary--text">
            TAKE A LOOK AROUND
          </h3>
        </v-col>
      </v-row>
      <v-row style="height: 90vh">
        <v-col style="height: 90vh">
          <v-lazy
            height="90vh"
            :options="{ threshold: 0.2 }"
            transition="fade-transition"
          >
            <iframe
              :src="floorplan.floorplan_matterport_url"
              width="100%"
              height="100%"
              loading="lazy"
              title="3D floorplan"
              class="rentpress-floorplan-virtual-tour-frame"
            ></iframe>
          </v-lazy>
        </v-col>
      </v-row>
      <v-row>
        <v-row justify="center" class="mx-5 py-4">
          <v-col
            v-if="options.rentpress_application_link_section_url_tour != ''"
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="7"
          >
            <v-btn
              :color="primaryColor"
              x-large
              block
              :href="tourLink"
              @click="
                gtag('event', 'scheduletour_click_rentpress', {
                  property_name: floorplan.property_name,
                  city: floorplan.property_city,
                  floorplan_name: floorplan.floorplan_post_title
                })
              "
              class="rentpress-application-link-section-url-tour-button"
              :style="{ color: getContrastingTextColor(primaryColor) }"
            >
              Schedule Tour
            </v-btn>
          </v-col>
          <v-col cols="12" xl="4" lg="4" md="4" sm="4">
            <div v-if="floorplan.floorplan_parent_property_contact_type == '3'">
              <v-btn
                block
                :color="primaryColor"
                class="rentpress-inherited-font-family rentpress-cta-info"
                :style="
                  getOutlinedButtonStyle(
                    primaryColor,
                    options.rentpress_application_link_section_url_tour != ''
                  )
                "
                x-large
                :outlined="
                  options.rentpress_application_link_section_url_tour != ''
                "
                @click="
                  doContactAction();
                  gtag('event', 'requestinfo_click_rentpress', {
                    property_name: floorplan.property_name,
                    city: floorplan.property_city,
                    floorplan_name: floorplan.floorplan_post_title
                  });
                  openGravityFormsModal(floorplan.floorplan_post_id);
                "
              >
                Request Info
              </v-btn>
              <v-dialog
                v-model="propertyGravityForm"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                scrollable
              >
                <v-card tile>
                  <v-btn
                    color="#303030"
                    fab
                    dark
                    small
                    absolute
                    top
                    right
                    @click="propertyGravityForm = ''"
                    class="mt-6 mr-n3"
                    elevation="10"
                  >
                    <v-icon>{{ $vuetify.icons.values.close }}</v-icon>
                  </v-btn>
                  <div
                    class="floorplan-form-pop-up"
                    v-html="floorplanForm"
                    ref="gravityform"
                  ></div>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn
                block
                :color="primaryColor"
                class="rentpress-inherited-font-family rentpress-cta-info"
                :style="
                  getOutlinedButtonStyle(
                    primaryColor,
                    options.rentpress_application_link_section_url_tour != ''
                  )
                "
                x-large
                :outlined="
                  options.rentpress_application_link_section_url_tour != ''
                "
                :href="contactLink"
                @click="
                  gtag('event', 'requestinfo_click_rentpress', {
                    property_name: floorplan.property_name,
                    city: floorplan.property_city,
                    floorplan_name: floorplan.floorplan_post_title
                  })
                "
              >
                Request Info
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" xl="4" lg="4" md="4" sm="7">
            <v-btn
              v-if="hasUnits && applyLink"
              class="rentpress-inherited-font-family rentpress-cta-apply"
              :color="primaryColor"
              block
              x-large
              outlined
              :href="applyLink"
              :target="
                options.rentpress_apply_link_section === 'New Window'
                  ? '_blank'
                  : '_self'
              "
              :style="getOutlinedButtonStyle(primaryColor, true)"
              @click="
                gtag('event', 'applynow_click_rentpress', {
                  property_name: floorplan.property_name,
                  city: floorplan.property_city,
                  floorplan_name: floorplan.floorplan_post_title
                })
              "
            >
              Apply Now
            </v-btn>
            <v-btn
              v-if="
                !hasUnits &&
                  options.rentpress_application_link_section_url_waitlist != ''
              "
              :color="primaryColor"
              class="rentpress-inherited-font-family rentpress-cta-waitlist"
              :style="getOutlinedButtonStyle(primaryColor, true)"
              x-large
              block
              outlined
              :href="waitlistLink"
              @click="
                gtag('event', 'joinwaitlist_click_rentpress', {
                  property_name: floorplan.property_name,
                  city: floorplan.property_city,
                  floorplan_name: floorplan.floorplan_post_title
                })
              "
            >
              Join Waitlist
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </div>

    <div v-if="hasUnits && engrainMapLink" id="single_floorplan_sightmap">
      <v-lazy
        :min-height="100"
        :options="{ threshold: 0.5 }"
        transition="fade-transition"
      >
        <sight-map
          :units="floorplanUnits"
          :options="options"
          :link="engrainMapLink"
          :floorplans="[floorplan]"
          inFloorplanPage="true"
        ></sight-map>
      </v-lazy>
    </div>

    <v-lazy
      :min-height="100"
      :options="{ threshold: 0.5 }"
      transition="fade-transition"
    >
      <div
        v-if="similarFloorplans.length > 0"
        class="rentpress-similar-floorplans"
      >
        <v-row justify="center">
          <v-col cols="12" class="text-center mt-8 ">
            <h3
              class="rentpress-inherited-font-family text-h4 secondary--text rentpress-similar-floorplans-title rentpress-single-floorplan-more-options-title"
            >
              Explore More Options
            </h3>
          </v-col>
          <v-col
            class="rentpress-similar-floorplans-loop-item"
            v-for="similarFloorplan in similarFloorplans"
            :key="similarFloorplan.floorplan_code"
            cols="10"
            xl="3"
            lg="3"
            md="4"
            sm="8"
          >
            <a
              :href="similarFloorplan.floorplan_post_link"
              @click="
                gtag('event', 'viewproperty_click_rentpress', {
                  floorplan_name: floorplan.parent_property_name
                })
              "
            >
              <floorplan-card
                :floorplan="similarFloorplan"
                :options="options"
                :formatter="formatter"
              />
            </a>
          </v-col>
        </v-row>
      </div>
    </v-lazy>
    <script v-html="jsonld" type="application/ld+json"></script>
  </div>
</template>

<script>
import singleFloorplanInformation from "./single-floorplan-information.vue";
import floorplanCard from "./floorplan-card.vue";
import sightMap from "./sight-map.vue";

export default {
  name: "singleFloorplanPage",
  data: function() {
    return {
      hasSelectedUnit: false,
      unitHasApplyLink: false,
      selectedUnit: {},
      propertyGravityForm: "",
      jsonld: {
        // single floor plan schema
        "@type": "ItemPage",
        primaryImageOfPage: this.floorplan.floorplan_image,
        significantLink: this.floorplan.applyLink,
        about: {
          "@type": "Product",
          name: this.floorplan.floorplan_post_title,
          image: this.floorplan.floorplan_image,
          description: this.floorplan.floorplan_description,
          brand: this.options.site_name,
          offers: {
            "@type": "aggregateOffer",
            lowPrice: this.floorplan.floorplan_rent_min,
            highPrice: this.floorplan.floorplan_rent_max,
            priceCurrency: "USD",
            offerCount: this.floorplan.floorplan_units_available
          },
          sku: this.floorplan.floorplan_code
        },
        breadcrumb: [
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: this.options.site_name + " Home",
                item: this.options.site_url
              },
              {
                "@type": "ListItem",
                position: 2,
                // name: this.property.property_city,
                item: this.options.site_url + "/city/"
                // this.property.property_city
              },
              {
                "@type": "ListItem",
                position: 3
                // name: this.property.property_name,
                // item: this.property.property_post_link
              }
            ]
          }
        ],
        mainEntity: [
          {
            "@type": "FloorPlan",
            image: this.floorplan.floorplan_image,
            description: this.floorplan.floorplan_description,
            name: this.floorplan.floorplan_post_title,
            url: this.floorplan.floorplan_post_link,
            floorsize: this.floorplan.floorplan_sqft_min,
            isPlanForApartment: this.floorplan.floorplan_parent_property_name,
            numberOfBedrooms: this.floorplan.floorplan_bedrooms,
            numberOfBathroomsTotal: this.floorplan.floorplan_bathrooms,
            petsAllowed: this.displayPetText
          },
          {
            containedInPlace: {
              "@type": "LocalBusiness",
              name: this.floorplan.floorplan_parent_property_name,
              description: this.floorplan.property_description,
              priceRange: "",
              telephone: this.floorplan.property_phone_number,
              image: this.floorplan.floorplan_image,
              address: {
                "@type": "PostalAddress",
                streetAddress: this.floorplan.property_address,
                addressLocality: this.floorplan.property_city,
                addressRegion: this.floorplan.property_state,
                postalCode: this.floorplan.property_zip
              },
              geo: {
                "@type": "GeoCoordinates",
                latitude: this.floorplan.property_latitude,
                longitude: this.floorplan.property_longitude
              },
              "@id": this.floorplan.property_post_link
            }
          }
        ],
        "@context": "https://schema.org"
      }
    };
  },
  props: {
    floorplan: Object,
    similarFloorplans: Array,
    options: Object,
    formatter: Intl.NumberFormat,
    shortcode: [String, Object]
  },
  computed: {
    primaryColor() {
      const color =
        this.floorplan.property_use_accent_color == "1"
          ? this.floorplan.property_accent_color
          : this.options.rentpress_accent_color_section_input;
      return color;
    },
    engrainMapLink() {
      const engrain_url = this.floorplan.floorplan_parent_property_engrain_url;
      if (engrain_url) {
        return typeof engrain_url !== "undefined" ? engrain_url : "";
      }
      return "";
    },
    applyLink() {
      if (this.floorplan.floorplan_availability_url) {
        return this.floorplan.floorplan_availability_url;
      } else {
        return this.options
          .rentpress_application_link_section_default_application_url;
      }
    },
    unitParamString() {
      let paramString = "";
      if (this.hasSelectedUnit && this.selectedUnit.unit_code) {
        paramString =
          "&unit_name=" +
          this.selectedUnit.unit_name +
          "&unit_code=" +
          this.selectedUnit.unit_code;
        paramString = this.selectedLeaseTerm
          ? paramString + "&leaseTerm=" + this.selectedLeaseTerm
          : paramString;
      }
      return paramString;
    },
    contactLink() {
      let contactURL = this.options
        .rentpress_application_link_section_url_contact
        ? this.options.rentpress_application_link_section_url_contact
        : window.location.origin + "/contact";
      const baseURL =
        this.floorplan.floorplan_parent_property_contact_link != "" &&
        this.floorplan.floorplan_parent_property_contact_link != null
          ? this.floorplan.floorplan_parent_property_contact_link
          : contactURL;
      let queryStringDelimiter = baseURL.includes("?") ? "&" : "?";
      return (
        baseURL +
        queryStringDelimiter +
        "property_code=" +
        this.floorplan.floorplan_parent_property_code +
        "&property_name=" +
        this.floorplan.property_name +
        "&floorplan_code=" +
        this.floorplan.floorplan_code +
        "&floorplan_name=" +
        this.floorplan.floorplan_name +
        "&floorplan_bed=" +
        this.floorplan.floorplan_bedrooms +
        this.unitParamString
      );
    },
    tourLink() {
      let queryStringDelimiter = this.options.rentpress_application_link_section_url_tour.includes(
        "?"
      )
        ? "&"
        : "?";
      return (
        this.options.rentpress_application_link_section_url_tour +
        queryStringDelimiter +
        "property_code=" +
        this.floorplan.floorplan_parent_property_code +
        "&property_name=" +
        this.floorplan.property_name +
        "&floorplan_code=" +
        this.floorplan.floorplan_code +
        "&floorplan_name=" +
        this.floorplan.floorplan_name +
        "&floorplan_bed=" +
        this.floorplan.floorplan_bedrooms +
        this.unitParamString
      );
    },
    waitlistLink() {
      let queryStringDelimiter = this.options.rentpress_application_link_section_url_waitlist.includes(
        "?"
      )
        ? "&"
        : "?";
      return (
        this.options.rentpress_application_link_section_url_waitlist +
        queryStringDelimiter +
        "property_code=" +
        this.floorplan.floorplan_parent_property_code +
        "&property_name=" +
        this.floorplan.property_name +
        "&floorplan_code=" +
        this.floorplan.floorplan_code +
        "&floorplan_name=" +
        this.floorplan.floorplan_name +
        "&floorplan_bed=" +
        this.floorplan.floorplan_bedrooms +
        this.unitParamString
      );
    },
    floorplanUnits() {
      var unitCodes = [];
      if (Object.keys(this.selectedUnit).length) {
        unitCodes.push(this.selectedUnit.unit_name);
        return unitCodes;
      }
      if (this.floorplan.units.length) {
        const units = this.floorplan.units;
        for (var i = units.length - 1; i >= 0; i--) {
          if (Array.from(units[i].unit_name)[0] == "0") {
            units[i].unit_name = units[i].unit_name.substring(1);
          }
          unitCodes.push(units[i].unit_name);
        }
      }
      return unitCodes;
    },
    floorplanForm() {
      const contactType = this.floorplan.floorplan_parent_property_contact_type;
      const formEl = document.getElementById(
        this.floorplan.floorplan_parent_property_code + "_form_wrapper"
      );
      if (formEl && contactType && contactType != "Global Setting") {
        return formEl.innerHTML;
      }
      return "";
    },
    floorplanFeaturesExcludingUnitsButInAllUnits() {
      const floorplan = this.floorplan;

      // Parse floorplan_features safely
      let floorplanFeatures = [];
      if (floorplan.floorplan_features) {
        try {
          floorplanFeatures =
            typeof floorplan.floorplan_features === "string"
              ? JSON.parse(floorplan.floorplan_features)
              : floorplan.floorplan_features;
        } catch {
          floorplanFeatures = [];
        }
      }

      // Count occurrences of each feature across all units
      const unitFeaturesCount = new Map();
      const totalUnits = floorplan.units ? floorplan.units.length : 0;

      if (totalUnits > 0) {
        floorplan.units.forEach(unit => {
          if (!unit.unit_features) return;
          try {
            const features =
              typeof unit.unit_features === "string"
                ? JSON.parse(unit.unit_features)
                : unit.unit_features;

            features.forEach(f => {
              let featureString = f;
              if (typeof f === "object" && f.Title) {
                featureString = f.Title;
              }
              unitFeaturesCount.set(
                featureString,
                (unitFeaturesCount.get(featureString) || 0) + 1
              );
            });
          } catch {
            // skip invalid
          }
        });
      }
      // Keep features that are either not in any unit or appear in all units
      return floorplanFeatures.filter(f => {
        const count = unitFeaturesCount.get(f) || 0;
        return count === 0 || count === totalUnits;
      });
    },
    today() {
      var d = new Date();
      var weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      return weekday[d.getDay()];
    },
    hasUnits() {
      return this.floorplan.units && this.floorplan.units.length > 0;
    },
    community_amenities() {
      if (!this.floorplan.property_community_amenities) return [];
      try {
        const amenities = JSON.parse(
          this.floorplan.property_community_amenities
        );
        return [...new Set(amenities)];
      } catch (e) {
        console.warn("Invalid community amenities JSON:", e);
        return [];
      }
    },
    floorplan_features() {
      if (this.floorplan.floorplan_features) {
        try {
          return JSON.parse(this.floorplan.floorplan_features);
        } catch (e) {
          console.warn("Invalid floorplan features JSON:", e);
          return [];
        }
      }
      return [];
    },
    officeHours() {
      let officeHours = this.floorplan.property_office_hours
        ? JSON.parse(this.floorplan.property_office_hours)
        : "";
      let officeHoursStringsArray = {
        Monday: "",
        Tuesday: "",
        Wednesday: "",
        Thursday: "",
        Friday: "",
        Saturday: "",
        Sunday: ""
      };
      for (const [day, hour] of Object.entries(officeHours)) {
        let officeHoursString = "";
        if (hour.status === "replace") {
          officeHoursString += hour.append_text;
          officeHoursStringsArray[day] = officeHoursString;
          continue;
        }
        if (hour.status === "appointment") {
          officeHoursString += "By Appointment ";
        }
        if (hour.status === "closed") {
          officeHoursString += "Closed ";
        }
        if (
          hour.open != null &&
          hour.open &&
          hour.status !== "closed" &&
          hour.status !== "appointment"
        ) {
          officeHoursString += hour.open;
          if (hour.close != null && hour.close) {
            officeHoursString += " - " + hour.close;
          }
        }
        if (hour.append === "on" && hour.append_text) {
          officeHoursString += " " + hour.append_text;
        }
        officeHoursStringsArray[day] = officeHoursString;
      }
      return officeHoursStringsArray;
    },
    hasOfficeHours() {
      return !!(
        this.officeHours.Sunday !== "" ||
        this.officeHours.Monday !== "" ||
        this.officeHours.Tuesday !== "" ||
        this.officeHours.Wednesday !== "" ||
        this.officeHours.Thursday !== "" ||
        this.officeHours.Friday !== "" ||
        this.officeHours.Saturday !== ""
      );
    }
  },
  methods: {
    getContrastingTextColor(color) {
      if (!color) return "#202124";
      const c = color.replace("#", "");
      const rgb = parseInt(c, 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? "#202124" : "#FDFDFD";
    },
    // Determines if a color is dark enough to contrast on white, courtesy WCAG
    isColorDarkEnough(color) {
      if (!color) return false;
      const c = color.replace("#", "");
      const rgb = parseInt(c, 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      // If brightness is less than or equal to 128, it's dark enough
      return brightness <= 128;
    },
    getOutlinedButtonStyle(color, outlined) {
      // Only apply for outlined buttons
      if (!outlined) {
        return { color: this.getContrastingTextColor(color) };
      }
      if (this.isColorDarkEnough(color)) {
        return {
          color: color,
          borderColor: color
        };
      } else {
        return {
          color: "#000000",
          borderColor: "#000000"
        };
      }
    },
    navigateToExternalSite(newLocation) {
      if (newLocation.includes("http")) {
        window.open(newLocation, "_blank");
      } else {
        window.open("http://" + newLocation, "_blank");
      }
    },
    navigateTo(newLocation) {
      window.location = newLocation.includes("http")
        ? newLocation
        : "http://" + newLocation;
    },
    navigateToPost: function(post_id) {
      window.location = "/?page_id=" + post_id;
    },
    doContactAction() {
      this.$refs.floorplanInformation.openGravityFormsModal("1");
    },

    setSelectedUnit(unit) {
      this.selectedUnit = unit;
    }
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState === "complete") {
        if (window.location.href.includes("virtual_tour_section=true")) {
          this.$vuetify.goTo("#rentpress-virtual-tour");
        }
      }
    };
  },
  components: {
    singleFloorplanInformation,
    floorplanCard,
    sightMap
  }
};
</script>

<style>
.rentpress-shortcode-single-floorplan-page-wrapper .pre-formatted {
  white-space: pre-wrap !important;
}

.rentpress-shortcode-single-floorplan-page-wrapper #community_amenities,
.rentpress-shortcode-single-floorplan-page-wrapper #floorplan_features {
  columns: 3;
  text-indent: -1.7rem;
  padding-left: 1.7rem;
  column-gap: 2.5rem;
}
#community_amenities > div,
#floorplan_features > div {
  line-height: 1;
}

.rentpress-office-hours-list {
  text-indent: -1.7rem;
  padding-left: 1.7rem;
  list-style-type: none;
}

.rentpress-shortcode-single-floorplan-page-row {
  margin: auto;
}

@media only screen and (min-width: 1200px) {
  .rentpress-shortcode-single-floorplan-page-row {
    max-width: 1200px !important;
  }
  .rentpress-floorplan-carousel,
  .rentpress-floorplan-carousel-item,
  .rentpress-floorplan-carousel-image {
    max-height: 600px !important;
  }
}

@media only screen and (max-width: 1200px) {
  .rentpress-shortcode-single-floorplan-page-wrapper #community_amenities,
  .rentpress-shortcode-single-floorplan-page-wrapper #floorplan_features {
    columns: 2;
  }
}

@media only screen and (max-width: 600px) {
  .rentpress-shortcode-single-floorplan-page-wrapper #community_amenities,
  .rentpress-shortcode-single-floorplan-page-wrapper #floorplan_features {
    columns: 1;
    column-gap: 0px;
  }
  .rentpress-shortcode-single-floorplan-page-row {
    padding: 3%;
  }
}

.rentpress-floorplan-virtual-tour-frame {
  border: 0;
}
</style>
